var userProfileStoreName = 'userProfile';

export { userProfileStoreName as u };
